import Backbone from 'backbone'
import template from './publish-alert-confirmation.hbs'

/**
 * A confirmation that the alert(s) were generated after the user clicks "Publish"
 */
const PublishAlertForm = Backbone.View.extend({

	tagName: 'form',

	className: 'panel',

	events: {
		'submit': 'submit'
	},

	initialize(options = {}) {
		this.options = options
	},

	render: function () {
		this.$el.empty().append(template({
			recipientCount: this.options.recipientCount,
			domainTypeLabel: this.options.domainTypeLabel
		}))
		return this
	},

	submit(e) {
		e && e.preventDefault()
		this.trigger('done')
	}

})

export default PublishAlertForm
PublishAlertForm.__filename__ = 'alerts/publish-alert-confirmation.js'
